import React, { useState, useEffect } from 'react';
import { Modal, Button, CheckboxControl, TabPanel } from '@wordpress/components';
import Cookies from 'js-cookie';

const ColumnSettingsModal = ({ columns, isOpen, onClose, onApplySetting }) => {
    const [settings, setSettings] = useState({});

    // Load settings from cookies when modal opens
    useEffect(() => {
        if (isOpen) {
            const savedSettings = Cookies.get('admin_settings');
            if (savedSettings) {
                setSettings(JSON.parse(savedSettings));
            } else if (columns && columns.length > 0) {
                // Initialize with all fields, using their isShow value as default
                const initialSettings = columns.reduce((acc, col) => {
                    acc[col.accessor] = col.isShow ?? true;
                    return acc;
                }, {});
                setSettings(initialSettings);
            }
        }
    }, [isOpen, columns]);

    const handleChange = (key, value) => {
        setSettings(prev => ({ ...prev, [key]: value }));
    };

    const handleSaveSettings = () => {
        Cookies.set('admin_settings', JSON.stringify(settings), { expires: 7 });
        onApplySetting(settings);
        onClose();
    };

    if (!isOpen) return null;

    // ✅ Group all columns (not filtering isShow anymore)
    const groupedColumns = columns.reduce((groups, col) => {
        const category =
            col.category ||
            (col.accessor.includes('price')
                ? 'Pricing'
                : col.accessor.includes('weight') ||
                  col.accessor.includes('length') ||
                  col.accessor.includes('width') ||
                  col.accessor.includes('height')
                ? 'Dimensions'
                : col.accessor.includes('stock') ||
                  col.accessor.includes('backorder')
                ? 'Inventory'
                : col.accessor.includes('description') ||
                  col.accessor.includes('note')
                ? 'Content'
                : col.accessor.includes('image') ||
                  col.accessor.includes('gallery')
                ? 'Media'
                : col.accessor.includes('category') ||
                  col.accessor.includes('tag')
                ? 'Taxonomy'
                : 'General');

        if (!groups[category]) groups[category] = [];
        groups[category].push(col);
        return groups;
    }, {});

    const tabs = Object.keys(groupedColumns).map(category => ({
        name: category.toLowerCase().replace(/\s+/g, '-'),
        title: category,
        className: `tab-${category.toLowerCase().replace(/\s+/g, '-')}`
    }));

    return (
        <Modal
            title="Settings"
            onRequestClose={onClose}
            style={{
                maxWidth: '1100px',
                width: '90%',
                overflowY: 'auto',
            }}
        >
            <TabPanel
                className="column-settings-tab-panel"
                activeClass="is-active"
                tabs={tabs}
            >
                {(tab) => {
                    const category = tab.title;
                    const groupCols = groupedColumns[category];
                    return (
                        <div style={{ marginTop: '20px' }}>
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(4, 1fr)',
                                    gap: '10px 25px',
                                    background: '#fafafa',
                                    padding: '12px 15px',
                                    borderRadius: '8px',
                                    border: '1px solid #eee',
                                }}
                            >
                                {groupCols.map(column => (
                                    <div key={column.accessor} style={{ display: 'flex', alignItems: 'center' }}>
                                        <CheckboxControl
                                            label={column.Header}
                                            checked={settings[column.accessor] ?? column.isShow ?? true}
                                            onChange={value => handleChange(column.accessor, value)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                }}
            </TabPanel>

            <div style={{ marginTop: '25px', textAlign: 'right' }}>
                <Button
                    isPrimary
                    onClick={handleSaveSettings}
                    style={{ marginRight: '10px' }}
                >
                    Save Settings
                </Button>
            </div>
        </Modal>
    );
};

export default ColumnSettingsModal;
